import theme from '@app/theme';
const {
  commons: { rating },
} = theme;

export default function getColorByRating(score) {
  switch (true) {
    case score >= 4.7:
      return rating.gradeA;
    case score >= 4.2 && score < 4.7:
      return rating.gradeB;
    case score >= 3.7 && score < 4.2:
      return rating.gradeC;
    case score >= 1 && score < 3.7:
      return rating.gradeD;
    default:
      return rating.none;
  }
}
